import { Component } from '@theme/component';

/*
 * FIFTY BUTIK — static header component.
 * Header geometry, desktop/mobile mode and visibility are resolved by
 * render-blocking CSS before first paint. No ResizeObserver, scroll state,
 * overflow measurement or late sizing is allowed here.
 */
class HeaderComponent extends Component {}

if (!customElements.get('header-component')) {
  customElements.define('header-component', HeaderComponent);
}
